import { bookingsLoginUserAccountSeeAllServicesClick } from '@wix/bi-logger-bookings-data/v2';
import { CreditCard } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { ActionsMenuLayout } from 'wix-ui-tpa/cssVars';
import { useBiLogger } from '../../../../../core/bi/biLoggerFactory';
import { useApplicationContext } from '../../../../../core/hooks/useApplicationContext';
import {
  ActionButtonProps,
  ActionButtonUiTypes,
  ActionsMenuType,
  BookingsGroup,
  MemberAreaClickActions,
} from '../../../../../types';
import {
  ActionsButtonsDataHooks,
  ViewSubscriptionDataHooks,
} from '../../datahooks';
import { classes as classesActionsMenu } from '../../ManageButton/ManageButton.st.css';

export interface ViewSubscriptionProps extends ActionButtonProps {
  group: BookingsGroup;
}

export const ViewSubscription: FC<ViewSubscriptionProps> = ({
  group,
  type,
  onActionClick,
}) => {
  const { t } = useTranslation();
  const state = useApplicationContext();
  const { actions, selectedTab } = state;
  const biLogger = useBiLogger(state);

  if (type !== ActionButtonUiTypes.MENU) {
    return null;
  }

  const handleClick = () => {
    biLogger?.report(
      bookingsLoginUserAccountSeeAllServicesClick({
        action: MemberAreaClickActions.ViewSubscription,
        referralInfo: selectedTab.type,
      }),
    );
    actions.clickOnViewSubscription({ group });
  };

  return (
    <div data-hook={ViewSubscriptionDataHooks.Main}>
      <ActionsMenuLayout
        className={classesActionsMenu.actionMenuLayout}
        data-hook={ActionsButtonsDataHooks.ViewSubscription}
      >
        <ActionsMenuLayout.Item
          content={t(
            'app.my-bookings-widget.manage-actions.view-subscription.label',
          )}
          onClick={() => {
            handleClick();
            onActionClick?.(ActionsMenuType.VIEW_SUBSCRIPTION);
          }}
          prefixIcon={<CreditCard />}
        />
      </ActionsMenuLayout>
    </div>
  );
};
